import SelectFilter from './SelectFilter.component';

export default SelectFilter;
